'use client';

import { Product } from 'shared/types/product/Product';
import ProductSlider, { ProductSliderProps } from 'components/gruenland/organisms/product-slider/ProductSlider';
import { desktop } from 'helpers/utils/screensizes';
import { DataSource } from 'types/datasource';
import { useWishlist } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';

function ProductSliderTastic({ data }: TasticProps<DataSource<{ items: Product[] }> & ProductSliderProps>) {
  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();

  if (!data?.data?.dataSource?.items) return <p>No products found.</p>;

  return (
    <ProductSlider
      wishlist={wishlist}
      products={data.data.dataSource.items}
      addToWishlist={async (lineItem, count) => {
        if (wishlist) await addToWishlist(wishlist, lineItem, count);
      }}
      removeLineItem={async (lineItem) => {
        if (wishlist) await removeLineItem(wishlist, lineItem);
      }}
      slidesPerView={1.5}
      slidesPerGroup={1}
      breakpoints={{
        [desktop]: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      }}
    />
  );
}

export default ProductSliderTastic;
